<template>
  <div class="pdf-viewer-container">
    <pdf
      v-if="viewState === 'loaded' && pdfSource"
      :src="pdfSource"
      style="height: 100vh; width: 100vw; padding: 0"
    />
    <div v-else-if="viewState === 'denied'" class="access-denied">
      <p>Access Denied: You do not have permission to view this document.</p>
    </div>
    <div v-else-if="viewState === 'error'" class="load-error">
      <p>Unable to load PDF. Please try again later.</p>
    </div>
    <div v-else class="loading">
      <p>Loading PDF...</p>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import Axios from "axios";
import config from "@/config";

export default {
  name: "PdfViewer",
  components: { pdf }, // <-- регистрируем как 'pdf'
  data() {
    return {
      pdfSource: null,
      viewState: "loading",
    };
  },
  beforeDestroy() {
    if (
      this.pdfSource &&
      typeof this.pdfSource === "string" &&
      this.pdfSource.indexOf("blob:") === 0
    ) {
      URL.revokeObjectURL(this.pdfSource);
    }
  },
  mounted() {
    this.validateAccess();
  },
  methods: {
    async validateAccess() {
      const code = this.$route.query.code;
      const fragment = new URLSearchParams(window.location.hash.substring(1));
      const link = fragment.get("link");

      if (!code || !link) {
        this.viewState = "denied";
        return;
      }

      await this.fetchPdf(code, link);
    },
    async fetchPdf(code, link) {
      const url =
        `${config.apiBaseUrl}pdf` +
        `?code=${encodeURIComponent(code)}` +
        `&link=${encodeURIComponent(link)}`;

      try {
        const { data: blob } = await Axios.get(url, { responseType: "blob" });
        this.pdfSource = URL.createObjectURL(blob);
        this.viewState = "loaded";
      } catch (error) {
        const status = error.response && error.response.status;
        this.viewState = status === 401 || status === 403 ? "denied" : "error";
      }
    },
  },
};
</script>

<style scoped>
.pdf-viewer-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
  box-sizing: border-box;
}

.access-denied {
  text-align: center;
  font-size: 1.5em;
  padding-top: 20vh;
  color: red;
}

.loading {
  text-align: center;
  font-size: 1.5em;
  padding-top: 20vh;
}

.load-error {
  text-align: center;
  font-size: 1.5em;
  padding-top: 20vh;
  color: red;
}
</style>
